/**
 * @param {string} tag
 * @param {object} attributes
 * @returns {HTMLElement}
 */

export function createMarkup(tag, attributes = {}) {
  const element = document.createElement(tag);
  for (const key in attributes) {
    if (attributes[key] !== null) element.setAttribute(key, attributes[key]);
  }

  return element;
}